import { $location, YLocationParams, YRoute } from '../../y/location';
import { yResolve } from '../../y/util';
import { UIButtonMenuItemBase, UIMenu, UIMenuItem } from '../menu';
import { UIScreen } from '../screen';
import { UIMenuHeaderOptions } from './menu-bar';

interface UINavigationScreenItem extends UIButtonMenuItemBase {
    path: string | string[];
    screen: (match: YLocationParams) => UIScreen;
    secondary?: (UIMenuItem | UINavigationItem)[];
}

interface UINavigationSecondaryItem extends UIButtonMenuItemBase {
    path: string | string[];
    screen?: undefined;
    secondary: (UIMenuItem | UINavigationItem)[];
}

type UINavigationItem = UINavigationScreenItem | UINavigationSecondaryItem;

function buildMenu(items: (UIMenuItem | UINavigationItem)[], path: string[], routes: YRoute[], root_menu?: UIMenu, menu_header_options?: UIMenuHeaderOptions, parent_match?: () => boolean): UIMenu {
    const menu = new UIMenu;
    const menu_items: UIMenuItem[] = [];

    root_menu ??= menu;

    const secondaries: [string[], UIMenu][] = [];

    for(const i of items) {
        if('path' in i) {
            const when = i.when;
            if(when === false) continue;

            const full_path = typeof i.path == 'string' ? [...path, i.path] : [...path, ...i.path];

            const menu_item: UIMenuItem = {
                title: i.title,
                icon: i.icon,
                key: i.key,
                link: full_path,
                when: when,
                highlight: i.screen ? (() => $location.at(full_path)) : (() => $location.under(full_path)),
            }

            const match = typeof when == 'function' ? (parent_match ? () => parent_match() && when() : () => when()) : parent_match;

            if(i.secondary) {
                secondaries.push([full_path, buildMenu(i.secondary, full_path, routes, root_menu, menu_header_options, match)]);
            }

            if(i.screen) {
                routes.push({
                    path: full_path,
                    screen: i.screen,
                    menu: () => root_menu,
                    menu_header_options: () => menu_header_options,
                    match: match
                });
            } else {
                routes.push({
                    path: full_path,
                    redirect: () => {
                        for(const s of i.secondary) {
                            if('path' in s) {
                                if(yResolve(s.when) !== false) {
                                    return typeof s.path == 'string' ? [...full_path, s.path] : [...full_path, ...s.path];
                                }
                            }
                        }
                        return;
                    }
                })
            }

            menu_items.push(menu_item);
        } else {
            menu_items.push(i);
        }
    }

    menu.items = menu_items;

    if(secondaries.length) {
        menu.secondary = () => {
            for(const s of secondaries) {
                if($location.under(s[0])) {
                    return s[1];
                }
            }

            return;
        }
    }

    menu.first_path_func = () => calcFirstPath(items, path);

    return menu;
}

function calcFirstPath(items: (UIMenuItem | UINavigationItem)[], subpath: string[]): string[] | undefined {
    for(const i of items) {
        if('path' in i) {
            if(yResolve(i.when) === false) continue;
            const full_path = typeof i.path == 'string' ? [...subpath, i.path] : [...subpath, ...i.path];

            if(i.screen)
                return full_path;

            if(i.secondary) {
                const r = calcFirstPath(i.secondary, full_path);
                if(r) return r;
            }
        }
    }

    return;
}

export function uiBuildNavigationMenu(items: (UIMenuItem | UINavigationItem)[], menu_header_options?: UIMenuHeaderOptions, prefix: string[] = []): [UIMenu, YRoute[]] {
    const routes: YRoute[] = [];
    const menu = buildMenu(items, prefix, routes, undefined, menu_header_options);
    return [menu, routes]
}
